import { createAction, handleActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';
import { pender } from 'redux-pender';
import axios from 'axios';

const HomeAPIUri = process.env.NODE_ENV === 'production' ? 'https://api.smafolk.co.kr/api/home/deedee' : 'http://localhost:8080/api/home/deedee';
const LookbookAPIUri = process.env.NODE_ENV === 'production' ? 'https://api.smafolk.co.kr/api/lookbook/deedee-lookbook' : 'http://localhost:8080/api/lookbook/deedee-lookbook';

function getHomeAPI() {
    return axios.get(HomeAPIUri);
}

function getLookbookAPI() {
    return axios.get(LookbookAPIUri);
}

const GET_HOME = 'fetch/GET_HOME';
const GET_LOOKBOOK = 'fetch/GET_LOOKBOOK';

export const getHome = createAction(GET_HOME, getHomeAPI);
export const getLookbook = createAction(GET_LOOKBOOK, getLookbookAPI);

const initialState = Map({
    home: Map({
        mainCarouselText1: 'Loading...',
        mainCarouselText2: 'Loading...',
        mainCarousel1: Map({ url: '', index: '' }),
        mainCarousel2: Map({ url: '', index: '' }),
        mainCarousel3: Map({ url: '', index: '' }),
        instaImages1: Map({ url: '', index: '' }),
        instaImages2: Map({ url: '', index: '' }),
        instaImages3: Map({ url: '', index: '' }),
        instaImages4: Map({ url: '', index: '' }),
        bottomCarouselTitle: 'Loading...',
        bottomCarouselText1: 'Loading...',
        bottomCarouselImages1_1: Map({ url: '', index: '' }),
        bottomCarouselImages1_2: Map({ url: '', index: '' }),
        bottomCarouselImages1_3: Map({ url: '', index: '' }),
        bottomCarouselImages1_4: Map({ url: '', index: '' }),
        bottomCarouselDescription: 'Loading...',
        bottomCarouselDescription_M: 'Loading...',
        aboutImagesLeft: Map({ url: '', index: '' }),
        aboutImagesMiddle: Map({ url: '', index: '' }),
        aboutImagesRight: Map({ url: '', index: '' })
    }),
    lookbook: List([
        Map({
            index: 0,
            thumbnail: Map({url: '', index: ''}),
            seasonText: '',
            yearText: '',
            images: List([])
        })
    ])
});

export default handleActions({
    ...pender({
        type: GET_HOME,
        onSuccess: (state, action) => {
            const { home } = action.payload.data;
            return state.set('home', fromJS(home))
        }
    }),

    ...pender({
        type: GET_LOOKBOOK,
        onSuccess: (state, action) => {
            let lookbook = action.payload.data;
            lookbook.forEach((item, i) => {
                item.images = item.images.sort((a, b) => {
                    return a.url.split('_')[1] > b.url.split('_')[1] ? 1 : -1;
                });
            });

            return state.set('lookbook', fromJS(lookbook))
        }
    })
}, initialState);



// WEBPACK FOOTER //
// ./src/modules/fetchData.js